<template>
    <div>
        <Loading :loadingHide="loadingHide"></Loading>
        <Header></Header>
        <div class="container personHomePage" :class="device=='mobile'?'mobileStyle':''">
            <aside :class="device=='mobile'?'mobileStyle':''">
                <header>
                    <main>
                        <div class="left">
                            <div class="avatarWrap">
                                <img class="userImg" :src="user.avatar" alt="">
                            </div>
                        </div>
                        <div class="right">
                            <div class="userName">
                                <span>{{ user.name }}</span>
                            </div>
                            <div class="userNum">
                                <span><i>{{ authorCount }}</i>关注</span>
                                <span><i>{{ followingCount }}</i>粉丝</span>
                            </div>
                            <!-- <div>加入于：<br>{{ user.date }}</div> -->
                            
                            <div class="userFun" v-if="look == 'self'">
                                <el-link type="primary" @click="tabChange('personal','个人资料')">编辑资料</el-link>
                            </div>
                        </div>
                    </main>
                    <footer v-if="look == 'other'">
                        <div><span @click="giveLike(user.id)" :class="zansStatus? 'userLike ffe200' : 'userLike'"><i>{{ likeNum }}</i>赞</span></div>
                        <div v-if="!studentId ||  user.id != studentId"><span @click="attentionUser(user.id)" :class="followStatus? 'attention ffe200' : 'attention'">{{ followStatus? '已关注' : '关注' }}</span></div>
                        <!-- <div><span @click="attentionUser(user.id)" :class="followStatus? 'attention ffe200' : 'attention'">{{ followStatus? '已关注' : '关注' }}</span></div> -->
                    </footer>
                    
                </header>
                <nav v-if="device!='mobile' && look != 'other'">
                    <ul>
                        <li v-if="!loginBtnShow" :class="activeItem == 'lesson'? 'active' : ''" @click="tabChange('lesson','我的课程')">我的课程</li>
                        <li v-if="!loginBtnShow" :class="activeItem == 'myworks'? 'active' : ''" @click="tabChange('myworks','我的作品')">我的作品</li>
                        <li v-if="!loginBtnShow" :class="activeItem == 'myexam'? 'active' : ''" @click="tabChange('myexam','我的考试')">我的考试</li>
                    </ul>
                </nav>
            </aside>
            <section :class="device=='mobile'?'mobileStyle':''">
                <main>
                    <header>
                        <el-dropdown trigger="click" v-if="device=='mobile'" @command="commandChange">
                            <span class="el-dropdown-link">
                                {{activeItemName}}<i class="el-icon-arrow-down el-icon--right"></i>
                            </span>
                            <el-dropdown-menu slot="dropdown" class="selfPage">
                                <el-dropdown-item v-if="!loginBtnShow && this.hostName!=`kexie.${institutionConfig.baseDomainName}` && this.hostName!=`roborobo.${institutionConfig.baseDomainName}`" :command="{item:'lesson',itemName:'我的课程'}">我的课程</el-dropdown-item>
                                <el-dropdown-item :command="{item:'myworks',itemName:'我的作品'}">我的作品</el-dropdown-item>
                                <el-dropdown-item :command="{item:'myexam',itemName:'我的考试'}">我的考试</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                        <span v-else>{{activeItemName}}</span>
                    </header>
                    <Personal :community="true" v-if="activeItem == 'personal'"></Personal>
                    <article v-else>
                        <myWorks v-if="activeItem == 'myworks'" :refresh="refresh" :look="look"/>
                        <myexam v-if="activeItem == 'myexam'"/>
                        <lesson v-if="activeItem == 'lesson'"/>
                    </article>
                </main>
            </section>
        </div>
        <Foot></Foot>
    </div>
</template>
<script>
import Loading from '@/components/loading';
import Header from '@/components/header';
import Foot from '@/components/foot';
import communityApi from '@/request/api/community';
import myWorks from '@/views/myWorks/myWorks'
import myexam from '@/views/exam/myexam'
import lesson from '@/views/lesson/lesson'
import Personal from '@/components/personal';
import {mapGetters} from 'vuex'

export default {
    components: {
        Loading,
        Header,
        Foot,
        myWorks,
        myexam,
        lesson,
        Personal
    },
    computed: {
        ...mapGetters(['device', 'studentId']),
        loginBtnShow() {
            return this.$store.state.loginBtnShow;
        },
        userInfo() {
            return this.$store.state.userInfo;
        },
    },
    data() {
        return {
            user: {
                avatar: '',
                name: '',
                date: ''
            }, //当前user对象
            // defaultImg: require("@/assets/icon/notdata.png"),
            authorCount: 0, //关注数
            followingCount: 0, //粉丝数
            likeNum: 0, //点赞数
            zansStatus: false, //点赞状态
            followStatus: false, //关注状态
            loadingHide: false,
            userInfoState: false,
            worksListState: false,
            activeItem:'lesson',
            activeItemName:'我的课程',
            hostName: location.hostname,
            look: "",
            refresh: false,
        }
    },
    watch: {
        $route() {
            if(this.$route.query && !this.$route.query.id) {
                this.getPageInfo();
            } else if(this.$route.query && this.$route.query.id) {
                this.getPageInfo();
            }
        },
        userInfo() {
            if(!this.userInfo) {
                this.$router.replace('/home');
            } else if(this.$store.state.callback) {
                this.$store.commit('setCallback', null);
            }
        },
    },
    created() {
        $(document).scrollTop(0); //打开页面到顶部
        this.getPageInfo();
    },
    methods: {
        //获取当前user信息
        getPageInfo() {
            let id = "";
            if(this.$route.query && this.$route.query.id) {
                if(this.$route.query.id != this.studentId) {
                    this.look = 'other';
                    this.activeItem = 'myworks';
                    this.activeItemName ='我的作品';
                }
                id = this.$route.query.id;
            } else if(this.studentId) {
                id = this.studentId;
                this.look = "self";
                this.activeItem = 'lesson';
                this.activeItemName ='我的课程';
            }
            if(id) {
                this.refresh = true;
                communityApi.pageInfo(id, res => {
                    if(res.succeed) {
                        this.user = res.data.user? res.data.user : {};
                        this.authorCount = res.data.authorCount? res.data.authorCount : 0;
                        this.followingCount = res.data.followingCount? res.data.followingCount : 0;
                        this.likeNum = res.data.likeNum? res.data.likeNum : 0;
                        this.zansStatus = res.data.zansStatus? res.data.zansStatus : false;
                        this.followStatus = res.data.followStatus? res.data.followStatus : false;
                    }
                    this.refresh = false;
                    this.loadingHide = true;
                    this.userInfoState = true;
                })
            } else {
                this.$router.replace('/home');
            }
        },
        //登录
        personLogin() {
            this.$store.commit('setDialogVisible', true)
        },
        //点赞
        giveLike(id) {
            if(this.studentId) {
                if(this.zansStatus) {
                    communityApi.cancelLikeHomePage(id, res => {
                        if(res.succeed) {
                            this.zansStatus = false;
                            this.likeNum -= 1;
                        }
                    })
                } else {
                    communityApi.likeHomePage(id, res => {
                        if(res.succeed) {
                            this.zansStatus = true;
                            this.likeNum += 1;
                        }
                    })
                }
            } else {
                this.personLogin();
            }
        },
        //关注
        attentionUser(id) {
            if(this.studentId) {
                if(this.followStatus) {
                    communityApi.deleteFollow(id, res => {
                        if(res.succeed) {
                            this.followStatus = false;
                            this.followingCount -= 1;
                        }
                    })
                } else {
                    communityApi.follow(id, res => {
                        if(res.succeed) {
                            this.followStatus = true;
                            this.followingCount += 1;
                        }
                    })
                }
                
            } else {
                this.personLogin();
            }
        },
        //查看卡片用户
        goUserHome(id) {
            if(id == this.studentId) {
                this.$message({
                    message: '已经是当前用户',
                    type: 'warning'
                });
            }
        },
        tabChange(item,itemName){
            this.activeItem=item
            this.activeItemName=itemName
        },
        commandChange(data){
            this.activeItem=data.item
            this.activeItemName=data.itemName
        }

    }
}
</script>
<style lang="scss">
    .selfPage{
        .popper__arrow::after {
            border-bottom-color:#fff !important;
        }
        &.el-dropdown-menu {
            margin-top: -8px !important; 
        }
    }
    .personHomePage{
        display: flex;
        &.mobileStyle{
            display: block;
        }
        >aside{
            padding-top:10px;
            width:260px;
            &.mobileStyle{
                width: 100%;
            }
            >header{
                width: 100%;
                background: #fff;
                border-radius: 10px;
                padding: 10px;
                >main{
                    width: 100%;
                    display: flex;
                    .left{
                        width: 100px;
                        padding: 10px 0 0 10px;
                        .avatarWrap{
                            display: flex;
                            flex-direction: row;
                            justify-content: center;
                            align-items: center;
                            width: 90px;
                            height: 90px;
                            border: 3px solid var(--theme-color);
                            border-radius: 20px;
                            box-shadow: 4px 5px 12px rgba(0,0,0,.12);
                            overflow: hidden;
                            img{
                                height: 100%;
                            }
                        }
                        
                    }
                    .right{
                        flex: 1;
                        padding-top: 14px;;
                        .userName{
                            padding-left: 18px;
                            color: #000;
                            font-size: 18px;
                            font-weight: bold;
                        }
                        .userNum{
                            display: flex;
                            span{
                                flex: 1;
                                text-align: center;
                            }
                        }
                    }
                }
                >footer{
                    display: flex;
                    justify-content: center;
                    padding: 15px 0 0;
                    div{
                        flex: 1;
                        display: flex;
                        justify-content: center;
                    }
                }
            }
            >nav{
                width: 100%;
                background: #fff;
                border-radius: 10px;
                margin-top: 10px;
                overflow: hidden;
                ul{
                    width: 100%;
                    margin: 0;
                    li{
                        width: 100%;
                        height: 50px;
                        display: flex;
                        align-items: center;
                        padding-left: 30px;
                        cursor: pointer;
                        &.active{
                            background:var(--theme-color) ;
                            color: #fff;
                            font-weight: bold;
                        }
                    }
                }
            }
        }
        >section{
            flex: 1;
            padding: 10px;
            color: #000;
            &.mobileStyle{
                padding: 10px 0;
            }
            >main{
                width: 100%;
                background: #fff;
                border-radius: 10px;
                overflow: hidden;
                >header{
                    height: 50px;
                    padding-left: 18px;
                    color: #303133;
                    font-size: 16px;
                    font-weight: bold;
                    border-bottom: 1px solid #E4E7ED;
                    line-height: 50px;
                    position: relative;
                }
                >article{
                    padding: 20px;
                }
            }
        }
    }
    .personHomePage {
        min-height: 760px;
        line-height: 2;
    }
    .personHomePage .lawyer,
    .personHomePage .attorney-button {
        background-color: var(--theme-color);
    }
    .personHomePage .team_member:hover .lawyer {
        background-color: var(--theme-color);
    }
    .personHomePage .el-tabs__item.is-active {
        color: var(--theme-activeColor);
    }
    .personHomePage .el-tabs__active-bar {
        background-color: var(--theme-activeColor);
    }
    .personHomePage .el-tabs__item:hover {
            color: var(--theme-color);
    }
    .personHomePage .el-radio-button__inner:hover {
        color: var(--theme-color);
    }
    .personHomePage .el-radio-button__orig-radio:checked+.el-radio-button__inner {
        background-color: var(--theme-activeColor);
        border-color: var(--theme-activeColor);
        box-shadow: -1px 0 0 0 var(--theme-activeColor);
    }
    .personHomePage .personTitle {
        display: flex;
        flex-flow: row nowrap;
        justify-content: center;
        align-items: flex-end;
        margin: 50px 0;
    }
    .personHomePage .personTitle .avatarBox {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        width: 90px;
        height: 90px;
        border: 3px solid #fff;
        border-radius: 20px;
        box-shadow: 4px 5px 12px rgba(0,0,0,.12);
        overflow: hidden;
    }
    .personHomePage .personTitle .avatarBox .userImg {
        height: 100%;
    }
    .personHomePage .personTitle .userInfo {
        margin: 0 30px;
    }
    .personHomePage .personTitle .userInfo span{
        display: block;
        font-size: 13px;
    }
    .personHomePage .personTitle .userInfo span:nth-child(1) {
        color: #000;
        font-size: 18px;
        font-weight: bold;
        margin-bottom: 10px;
    }
    .personHomePage .personTitle .userNum {
        margin: 0 30px
    }
    .personHomePage .personTitle .userNum span{
        display: block;
        font-size: 13px;
    }
    .personHomePage .personTitle .userNum span i{
        font-style: initial;
        font-size: 18px;
        margin: 10px 5px;
    }
    .personHomePage .userFun{
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
    }
    .personHomePage .default  {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding-top: 70px;
        color: #8a8a8a;
        font-size: 15px;
        padding: 80px;
    }
    .personHomePage .default  img {
        width: 80px;
    }
    .personHomePage .user-panel {
        padding: 2px 0;
        overflow: hidden;
    }
    .personHomePage .user-panel li {
        position: relative;
        display: inline-block;
        font-size: 15px;
    }
    .personHomePage .user-eyes {
        display: flex;
        flex-flow: row nowrap;
        justify-content: center;
        margin-bottom: 0;
    }
    .personHomePage .user-eyes li:nth-child(1) {
        margin-right: 10px;
    }
    .personHomePage .user-eyes i {
        margin-right: 5px;
    }
    .personHomePage .user-eyes .like {
        padding: 9px;
        margin-right: 5px;
        background-image: url("../../assets/zan.png");
        background-repeat: no-repeat;
        background-position: center center;
        background-size: contain;
    }
    .personHomePage .user-panel.border-top {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        justify-content: flex-start;
        align-items: center;
    }
    .personHomePage .user-headimg {
        width: 25px;
        height: 25px;
        border-radius: 50%;
        margin-right: 4px;
        overflow: hidden;
        cursor: pointer;
    }
    .personHomePage .userLike i {
        font-style: initial;
        font-size: 15px;
        margin-right: 5px;
    }
    .personHomePage .ffe200 {
        background: #FFE200 !important;
    }
    .personHomePage .userLike,
    .personHomePage .attention {
        position: relative;
        width: 100px;
        color: #fff;
        display: block;
        height: 34px;
        font-size: 14px;
        line-height: 32px;
        background-color: var(--theme-color);
        margin-bottom: 14px;
        border: 0;
        color: #fff;
        text-align: center;
        border-radius: 5px;
        cursor: pointer;
        margin-top: 5px;
        box-shadow: 2px 2px 4px rgba(0,0,0,.1);
        overflow: hidden;
    } 
    .personHomePage .userLike,
    .personHomePage .attention {
        position: relative;
        width: 100px;
        color: #fff;
        display: block;
        height: 34px;
        font-size: 14px;
        line-height: 32px;
        background-color: var(--theme-activeColor);
        margin-bottom: 14px;
        border: 0;
        color: #fff;
        text-align: center;
        border-radius: 5px;
        cursor: pointer;
        margin-top: 5px;
        box-shadow: 2px 2px 4px rgba(0,0,0,.1);
        overflow: hidden;
    }
    .personHomePage .attention {
        margin-bottom: 0px;
    }
    .personHomePage .el-pagination {
        display: flex;
        flex-direction: row;
        justify-content: center;
        margin: 50px 0;
    }
    .personHomePage .el-pagination.is-background .el-pager li:not(.disabled).active {
        background-color: var(--theme-color);
        color: var(--theme-fontColor) !important;
    }
    .personHomePage .el-pagination.is-background .el-pager li:not(.disabled):hover {
        color: var(--theme-color);
    }
    @media (max-width: 690px) {
        .personHomePage .personTitle {
            flex-flow:  column;
            align-items: center;
        }
        .personHomePage .personTitle .userInfo span:nth-child(1) {
            text-align: center;
        }
    }
</style>


// WEBPACK FOOTER //
// src/views/personHome/personHome.vue